import * as React from 'react';
import { H1, Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { CancelSubscriptionFormContainer } from '../../modules/CancelSubscriptionForm/CancelSubscriptionFormContainer.js';

const CancelSubscriptionPage = ()=>{
    const { getLabel  } = useIntl();
    const labels = {
        title: getLabel('cancelSubscription.title'),
        description: getLabel('cancelSubscription.description')
    };
    return /*#__PURE__*/ React.createElement("section", {
        className: "cancel-subscription__container"
    }, /*#__PURE__*/ React.createElement(H1, {
        variant: "heading-large"
    }, labels.title), /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, labels.description), /*#__PURE__*/ React.createElement(CancelSubscriptionFormContainer, null));
};

export { CancelSubscriptionPage };
//# sourceMappingURL=CancelSubscriptionPage.js.map
